<div class="filter-table">
  <div class="form_search">
    <div class="m-b">
      <div class="form-group form-filter">
        <h3>Filtros</h3>
        <div class="col-8 d-flex justify-content-end">
          <button *ngIf="canClear" class="btn-filters" type="button" (click)="clearFilter()">
            <span class="font-icon"> cleaning_services</span>
            <span class="filter-text">Limpar Filtros</span>
          </button>
          <button *ngIf="canClose" class="font-icon btn btn-blue-1" type="button" (click)="onClose();">
            <span class="font-icon font-icon-close"> close </span>
          </button>
        </div>
      </div>
    </div>
    <form [formGroup]="form" (ngSubmit)="onSearch()" class="form-group d-flex flex-wrap">
      <div class="col-12 d-flex flex-wrap">
        <ng-container *ngFor="let item of filterData; let i = index" >
          <div [ngSwitch]="item.type" *ngIf="getfilter(item) as filter" [class]="'div-input ' + item.class">
            <label>
              <input *ngSwitchCase="'checkbox'" [type]="item.type" class="form-check-input me-2" [formControlName]="item.key ?? ''"  placeholder="Digite" />
            
              <b>{{item.label}} <sup *ngIf="item.required" class="text-danger ms-2">*</sup></b>
              <mat-form-field *ngSwitchCase="'rangeDate'" class="range-control">
                <mat-label>Digite um intervalo</mat-label>
                <mat-date-range-input [formGroup]="form" [rangePicker]="picker">
                  <input matStartDate [formControlName]="item.key_start ?? ''" placeholder="Data início">
                  <input matEndDate [formControlName]="item.key_end ?? ''" placeholder="Data fim">
                </mat-date-range-input>
                <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
              
              <ng-select *ngSwitchCase="'select'" [id]="item.key" class="ng-select-alternative"
                [items]="item.options" bindLabel="label" bindValue="id" [formControlName]="item.key ?? ''" placeholder="Selecione">
              </ng-select>
              
              <mat-form-field *ngSwitchCase="'mult-select'"  class="ng-mult-select">
                <mat-select [formControlName]="item.key ?? ''" multiple>
                  <mat-option *ngFor="let opt of item.options" [value]="opt['id']">{{opt['label']}}</mat-option>
                </mat-select>
              </mat-form-field>
              
              <input *ngSwitchCase="'cpf'" [id]="item.key" class="form-control"
                [formControlName]="item.key" (input)="maskCpf(item.key, $event)" placeholder="XXX.XXX.XXX-XX">
                
              <input *ngSwitchDefault [type]="item.type" class="form-control mb-2" [formControlName]="item.key ?? ''"  placeholder="Digite" />
            
            </label>
          </div>
          
        </ng-container>
      </div>


      <div class="col-12 d-flex justify-content-end">
        <ng-content></ng-content>
        <button *ngIf="canFilter" class="btn btn-blue-1" type="submit">Filtrar</button>
      </div>
    </form>
  </div>
</div>